export enum ServiceTransactionStatus {
    Initial = 0, 
    Complete = 9
}
